import React, { useEffect, useState } from 'react'
import API from 'lib/api'
import AuthenticatedPage from 'containers/AuthenticatedPage'
import { withRouter } from 'react-router-dom'

import { SALES_ORDERS_PAY_URL } from 'config/app'
import '../style.scss'
import { getMessage } from 'lib/translator'
import FullfillmentTable from './FullfillmentTable'

import Purchase from './Purchase'
import { hasGetClientSalesOrdersAccess } from 'pages/operations/SaleOrders/Details/ReDelivery/constant'

const RedeliveryFullfillment = (props) => {
  const { id } = props.match.params
  const [redelivery, setRedelivery] = useState(null)
  const [refresh, refreshData] = useState('')

  useEffect(() => {
    const getSalesOrdersData = async () => {
      try {
        const url = `${SALES_ORDERS_PAY_URL}/GetClientSalesOrder`
        const api = new API({ url })
        const response = await api.post({
          id: id.toString(),
        })
        setRedelivery(response)
      } catch (error) {
        console.error(error)
      }
    }

    if (hasGetClientSalesOrdersAccess()) {
      getSalesOrdersData()
    }
  }, [refresh])

  return (
    <div className="sale-order-summary-wrapper">
      <FullfillmentTable
        {...props}
        redelivery={redelivery}
        refreshData={refreshData}
      />
      <Purchase {...props} redelivery={redelivery} />
    </div>
  )
}

const RedeliveryFullfillmentWrapper = (props) => {
  return (
    <AuthenticatedPage className="sale-order-details" menu={props.menu}>
      <div className="flex-around">
        <h1>{getMessage('operations.dashboard.redeliveryOrder')}</h1>
      </div>

      <RedeliveryFullfillment {...props} />
    </AuthenticatedPage>
  )
}

export default withRouter(RedeliveryFullfillmentWrapper)
